module.exports = __webpack_public_path__ + "static/media/recent-two.00787442.png";